import { Checkbox } from "primereact/checkbox"
import { InputText } from "primereact/inputtext"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

const IdentificacionModelo390 = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const isGrupoEntidadesEnabled = values?.regimenEspecialGrupoEntidades

  const handleEsDominanteChange = () => {
    const newValue = !values?.esDominante
    setValue("esDominante", newValue)
    if (newValue) {
      setValue("esDependiente", false)
    }
  }

  const handleEsDependienteChange = () => {
    const newValue = !values?.esDependiente
    setValue("esDependiente", newValue)
    if (newValue) {
      setValue("esDominante", false)
    }
  }
  const fields: {
    label: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any
    code: $TSMigrationFixMe
  }[] = [
    {
      label: t("modelo390.identificacion.registroDevolucion"),
      code: "registroDevolucionMensual",
      value: values?.registroDevolucionMensual,
    },
    {
      label: t("modelo390.identificacion.regimenEspecialGrupo"),
      code: "regimenEspecialGrupoEntidades",
      value: values?.regimenEspecialGrupoEntidades,
    },
    {
      label: t("modelo390.identificacion.numeroGrupo"),
      code: "numeroGrupo",
      value: values?.numeroGrupo,
    },
    {
      label: t("modelo390.identificacion.art163SexiesCinco"),
      code: "tipoRegimenEspecialAplicable",
      value: values?.tipoRegimenEspecialAplicable,
    },
    {
      label: t("modelo390.identificacion.nifDominante"),
      code: "nifEntidadDominante",
      value: values?.nifEntidadDominante,
    },
    {
      label: t("modelo390.identificacion.declaradoConcurso"),
      code: "concursoAcreedores",
      value: values?.concursoAcreedores,
    },
    {
      label: t("modelo390.identificacion.optaCriterioCaja"),
      code: "regimenEspecialCriterioCaja",
      value: values?.regimenEspecialCriterioCaja,
    },
    {
      label: t("modelo390.identificacion.destinatarioCriterioCaja"),
      code: "destinatarioRegimenCriterioCaja",
      value: values?.destinatarioRegimenCriterioCaja,
    },
  ]

  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col'>
      <div className='tw-w-full tw-h-auto tw-flex tw-justify-start tw-items-center tw-gap-6 tw-py-1 tw-border-b tw-border-t tw-border-neutral-25 tw-px-6 tw-min-h-16 tw-text-left'>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-font-medium'>
            {t("taxSummary.declaracion.identificacionModelo.nif")}
          </span>
          <InputText
            className='tw-text-sm'
            value={values?.nif ?? ""}
            disabled
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-font-medium'>
            {t("taxSummary.declaracion.identificacionModelo.nameRazonSocial")}
          </span>
          <InputText
            className='tw-text-sm'
            value={values?.apellidosRazonSocial ?? ""}
            disabled
          />
        </div>
      </div>

      <div className='tw-w-full tw-h-fit tw-px-6 tw-divide-y tw-divide-neutral-25'>
        {fields.map((field, idx) =>
          idx === 2 ? (
            <div
              key={field.code}
              className='tw-flex tw-justify-between tw-items-center tw-py-3'
            >
              <div className='tw-flex tw-flex-col tw-text-left'>
                <span className='tw-text-xs tw-font-medium'>{field.label}</span>
                <InputText
                  className='tw-text-sm'
                  value={field.value ?? ""}
                  onChange={(e) => setValue(`${field.code}`, e.target.value)}
                  disabled={!isGrupoEntidadesEnabled}
                />
              </div>
              <span className='tw-text-sm'>
                {t("modelo390.identificacion.esDominante")}
              </span>
              <Checkbox
                id='esDominante'
                className={`${
                  isGrupoEntidadesEnabled
                    ? "tw-cursor-pointer"
                    : "tw-cursor-default"
                }`}
                checked={values?.esDominante}
                onChange={handleEsDominanteChange}
                disabled={!isGrupoEntidadesEnabled}
              />
              <span className='tw-text-sm'>
                {t("modelo390.identificacion.esDependiente")}
              </span>
              <Checkbox
                id='esDependiente'
                className={`${
                  isGrupoEntidadesEnabled
                    ? "tw-cursor-pointer"
                    : "tw-cursor-default"
                }`}
                checked={values?.esDependiente}
                onChange={handleEsDependienteChange}
                disabled={!isGrupoEntidadesEnabled}
              />
            </div>
          ) : idx === 4 ? (
            <div
              key={field.code}
              className='tw-flex tw-justify-between tw-items-center tw-py-3'
            >
              <span className='tw-text-sm tw-font-base'>{field.label}</span>
              <InputText
                className='tw-text-sm'
                value={field.value ?? ""}
                onChange={(e) => setValue(field.code, e.target.value)}
              />
            </div>
          ) : (
            <div
              key={field.code}
              className='tw-flex tw-justify-between tw-items-center tw-py-3'
            >
              <span className='tw-text-sm'>{field.label}</span>
              <Checkbox
                id={field.code}
                checked={field.value}
                onChange={() => setValue(field.code, !field.value)}
              />
            </div>
          )
        )}
      </div>
      <span className='tw-text-xs tw-text-right tw-w-full tw-py-1 tw-px-6'>
        {t("taxSummary.declaracion.infoMsg")}
      </span>
    </div>
  )
}
export default IdentificacionModelo390
